
import $ from 'jquery';
/* Header Search */

$(document).ready(function() {

    $(".header-search-button").focus(function(e) {
      if($( ".menu-submenu" ).hasClass( "menu-open" )){
        $('.menu-submenu').removeClass("menu-open");
        $(".menu-arrow-down").attr("aria-expanded", "false");
      }
    });

	//add Active Class on hover

const menuItems = document.querySelectorAll('#menu-main-desktop .t1-menu-li');

menuItems.forEach(item => {
  item.addEventListener('mouseenter', function() {
    item.classList.add('active');  // Add 'active' class on hover
  });

  item.addEventListener('mouseleave', function() {
    item.classList.remove('active');  // Remove 'active' class when hover ends
  });
});

	$(".menu-parent a").focus(function(e){
	  $(this).closest('ul').find('nav').css('display', 'none');
      $(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"});
	  $(this).parent().children().children().eq(1).closest('nav').css('display', 'grid');
    });	

    $(".menu-parent a").on('keydown blur', function(e) {
      if (e.shiftKey && e.keyCode === 9) {
        if($(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"})){
          $(this).parent().children().children().eq(1).css({"opacity": "0", "z-index": "-1"});
        }
      }
    });

    $(".menu-arrow-down").focus(function(e){
      $(".menu-l2").css({"opacity": "0", "z-index": "-1"});
    });

  });


$( document ).ready( function () {

	/**
	 * Run the header mutation observer and run it always.
	 */
	// headerMutationObserver();
	// headerMobileMutationObserver();
	// menuOpenMutationObserver();
	// // reAlignCookieConsentBasedOnGeoRibbon();

    // // Accessiblity Issue fix for Country Site dropdown - bug #783819
    // headerLangMutationObserver();

	// const appHeight = () => document.documentElement.style.setProperty( '--app-height', `${window.innerHeight}px` )
	// const headerMobileHeight = () => {
	// 	const headerMobileEle = document.querySelector('.header-mobile');
	// 	if(headerMobileEle){
	// 		document.documentElement.style.setProperty( '--header-mobile-height', `${headerMobileEle.offsetHeight}px` )
	// 	}
	// }
	// const headerDesktopHeight = () => {
	// 	const headerTopbarEle = document.querySelector('.header-topbar');
	// 	if(headerTopbarEle){
	// 		document.documentElement.style.setProperty( '--header-topbar-height', `${headerTopbarEle.offsetHeight}px` )
	// 	}
	// }

	// const adminBarHeight = () => {
	// 	const adminBarEle = document.querySelector('#wpadminbar');
	// 	if(adminBarEle) {
	// 		document.documentElement.style.setProperty( '--admin-bar-height', `${adminBarEle.offsetHeight}px` );
	// 	} else {
	// 		document.documentElement.style.setProperty( '--admin-bar-height', `0px` )
	// 	}
	// }

	/**
	 * Get the height of the breadcrumb
	 */
	// const subNavWrapperHeight = () => {
	// 	const subNavEle = document.querySelector('.sub-navigation-wrapper');
	// 	if(subNavEle) {
	// 		document.documentElement.style.setProperty( '--sub-navigation-wrapper-height', `${subNavEle.offsetHeight}px` );
	// 	} else {
	// 		document.documentElement.style.setProperty( '--sub-navigation-wrapper-height', `0px` )
	// 	}
	// }

	// window.addEventListener( 'resize', () => {
	// 	appHeight();
	// 	subNavWrapperHeight();
	// 	headerDesktopHeight();
	// 	adminBarHeight();
	// 	headerMobileHeight();
	// })
	// appHeight();
	// subNavWrapperHeight();
	// headerMobileHeight();
	// headerDesktopHeight();
	// adminBarHeight();


	// $('.header-topbar').hover(function(){
	// 	$('.header-topbar').addClass('hover')
	// 	$('.dark-gradient').addClass('hover')
	// 	$('.light-gradient').addClass('hover')
	// }, function(){
	// 	$('.header-topbar').removeClass('hover')
	// 	$('.dark-gradient').removeClass('hover')
	// 	$('.light-gradient').removeClass('hover')
	// })

	// $('.light-gradient').hover(function(){
	// 	$('.header-topbar').addClass('hover')
	// }, function(){
	// 	$('.header-topbar').removeClass('hover')
	// })

	// $('.dark-gradient').hover(function(){
	// 	$('.header-topbar').addClass('hover')
	// 	}, function(){
	// 	$('.header-topbar').removeClass('hover')
	//  })


	// let cgTopMenuItems  = $( '.header-topbar ul.menu > li' );
	// let cgSubNavigation = $( '.sub-navigation' );
	// let cgBreadcumbShadow = cgSubNavigation.css( 'box-shadow' );

	// cgTopMenuItems.hover( function () {

	// 	cgSubNavigation.css( 'box-shadow', 'none' );
	// } );

	// cgTopMenuItems.mouseleave( function () {

	// 	cgSubNavigation.css( 'box-shadow', cgBreadcumbShadow );

	// } );

	// --- Mega-menu (desktop) ---
	// $('.header-topbar-wrapper').hover(function(){
	// 	$('.header-topbar').addClass('hover')
	// 	// setTimeout(function(){
	// 	//   if ($('.header-nav li:hover').length > 0) {
	// 	//     $('.body-overlay').fadeIn(100)
	// 	//   }
	// 	// }, 200)
	// }, function(){
	// 	$('.header-topbar').removeClass('hover');
	// 	const menuSubmenu =  $('.header-bottom .header-nav li .menu-submenu')
	// 	if(menuSubmenu) {
	// 		menuSubmenu.removeClass('menu-open');
	// 		menuSubmenu.attr('aria-expanded',false);
	// 	}
	// 	$(".header-bottom .header-nav li .menu-arrow-down").attr("aria-expanded", "false");
	// 	// setTimeout(function(){
	// 	//   if ($('.header-nav li:hover').length <= 0) {
	// 	//     $('.body-overlay').fadeOut(100, function(){
	// 	//       $('.header-topbar').removeClass('hover')
	// 	//     })
	// 	//   }
	// 	// }, 200)
	// });

	/**
	 *
	 * @param {Event<HTMLButtonElement>} e
	 * @param {Boolean} hide
	 */
	// const toggleSubMenu = (e,hide = false) => {
	// 	/**
	// 	 * Get the clicked target
	// 	 * @type {HTMLButtonElement}
	// 	 */
	// 	const clickedButton = e.target;

	// 	/**
	// 	 *
	// 	 * @type {HTMLElement}
	// 	 */
	// 	const parentLi = clickedButton.parentElement;

	// 	/**
	// 	 * Get the submenu
	// 	 * @type {HTMLElement}
	// 	 */
	// 	const subMenu = parentLi ? parentLi.querySelector('.menu-submenu') : null;

	// 	if(subMenu && subMenu.classList.contains('menu-open')){
	// 		subMenu.classList.remove('menu-open');
	// 		subMenu.ariaExpanded = false;
	// 		clickedButton.ariaExpanded = false;
	// 	} else {
	// 		subMenu.classList.add('menu-open');
	// 		subMenu.ariaExpanded = true;
	// 		clickedButton.ariaExpanded = true;
	// 	}
	// }

	// const headerTopbarNode = document.querySelector('.header-topbar');

	// const menuArrowDownNode = headerTopbarNode ? headerTopbarNode.querySelectorAll('.menu-arrow-down') : [];
	// menuArrowDownNode.forEach((menuArrowDownItem) => {
	// 	menuArrowDownItem.addEventListener('click', toggleSubMenu )
	// })

	// const menuNavLiNodes = headerTopbarNode.querySelectorAll('.header-bottom .header-nav li');

	// menuNavLiNodes.forEach((menuLiEle) => {
	// 	menuLiEle.addEventListener('mouseenter', (e) => {
	// 		const subMenu = e.currentTarget.querySelector('.menu-submenu');
	// 		if(subMenu) {
	// 			subMenu.classList.add('menu-open');
	// 			subMenu.ariaExpanded = true;
	// 		}
	// 	})
	// 	menuLiEle.addEventListener('mouseleave', (e) => {
	// 		const subMenu = e.currentTarget.querySelector('.menu-submenu');
	// 		if(subMenu) {
	// 			subMenu.classList.remove('menu-open');
	// 			subMenu.ariaExpanded = false;
	// 		}
	// 	})
	// })



	// $(".menu>li>a").addClass("menu-acc");
	// $(".menu-acc").focus(function(e) {
	// 	if($( ".menu-submenu" ).hasClass( "menu-open" )){
	// 		$('.menu-submenu').removeClass("menu-open");
	// 		$(".menu-arrow-down").attr("aria-expanded", "false");
	// 	}
	// });

	// const closeOpenItems = () => {
	// 	const subMenus = headerTopbarNode ? headerTopbarNode.querySelectorAll('.menu-submenu'): [];
	// 	subMenus.forEach((el) => {
	// 		if(el.classList.contains('menu-open')){
	// 			el.classList.remove('menu-open');
	// 			el.ariaExpanded = false;
	// 		}
	// 	})
	// }

	// document.addEventListener('keydown', (e) => {
	// 	//e.keyCode is deprecated so use with e.code
	// 	if(e.code === 'Escape' || e.keyCode === 27) {
	// 		closeOpenItems();
	// 	}
	// })


    //const navigableElements = document.querySelectorAll('.header-lang-inner .header-lang-top button, .header-lang-middle input, .lang-list ul a');
    // navigableElements.forEach((element) => {
    //     element.setAttribute("tabindex", "-1");
    // });



} );

// --- Resizing function for menus ---

// var myScreenSize = getScreenSize()

// function getScreenSize() {
// 	if ( $( window ).width() > 767 ) {
// 		return 'M'
// 	} else {
// 		return 'S'
// 	}
// }

// Remove all classes and styles to hide menus when we change screen type

// $( window ).resize( lodash.debounce(
// 	function () {
// 		var newSize = getScreenSize()

// 		if ( newSize != myScreenSize ) {
// 			$( '.body-overlay, .mobile-nav, .mobile-menu, .menu-submenu, .menu-submenu2, .sub-navigation > ul, .sub-navigation .menu-parent nav' ).attr( 'style', '' )
// 			$( 'body' ).removeClass( 'nooverflow' )
// 			$( '.header-topbar-wrapper .header-nav a, .header-mobile-bar, .mobile-nav-button, .sub-navigation .menu-parent, .subnav-mobile-button' ).removeClass( 'opened' )
// 			$( '.menu-parent' ).removeClass( 'active' )
// 		}

// 		myScreenSize = getScreenSize()
// 	}, 100
// ) )

// --- Search menu ---

// Open search menu

$( '.header-search-open' ).click( function () {
	if ( $( '.mobile-nav' ).is( ':visible' ) ) {
		$( '.mobile-nav-button' ).click()
	}
	$( '.header-search, .mobile-search-button' ).addClass( 'active' );
	$( '.header-mobile-bar' ).addClass( 'opened' )
	$( '.header-mobile, .header-mobile-bar' ).css( 'z-index', 104 )
	$( 'body' ).addClass( 'nooverflow' )
	$( '.body-overlay2' ).fadeIn()

	const searchFormInput = document.querySelector('#searchform #keyword');
	if(searchFormInput){
		searchFormInput.focus()
	}
} )

// Close Search on Esp key

$( document ).keyup( function ( e ) {
	if ( e.which == 27 ) {
		$( ".header-search" ).removeClass( 'active' );
		$( 'body' ).removeClass( 'nooverflow' );
		$( '.body-overlay2' ).fadeOut();
	}
} );

// Close search menu

$( '.header-search-close, .body-overlay2' ).click( function ( e ) {
	e.preventDefault()
	$( '.header-search, .mobile-search-button' ).removeClass( 'active' );
	$( '.header-mobile-bar' ).removeClass( 'opened' )
	$( '.header-mobile, .header-mobile-bar' ).css( 'z-index', 103 )
	$( '.body-overlay2' ).fadeOut()
	$( "div.demo" ).scrollTop( 300 );
	if ( !$( '.mobile-nav' ).is( ':visible' ) ) {
		$( 'body' ).removeClass( 'nooverflow' )
	}
} )

// Show results

function showSearchResults() {
	$( '.header-search-bottom' ).hide()
	$( '.header-search-results' ).show()
}

$( '.header-search .form--oneliner input' ).on( 'keyup', function () {
	showSearchResults()
} )

// Click search button

$( '.header-search input[type="submit"]' ).click( function ( e ) {
	e.preventDefault()
	showSearchResults()
} )


function MenuWidthCalc() {
	if ( Math.round( window.devicePixelRatio * 100 ) == 150 ) {
		$( ".advertImageWrapper" ).addClass( 'advertImageWrapper150 ' );
	}
	if ( $( window ).width() > 767 ) {
		$( ".header-topbar-wrapper .menu-l2" ).each( function () {
			// Test if the div element is empty

			let childElementCount = this.children.length;
			if ( childElementCount > 9 ) {
				$( this ).addClass( 'menu-l2-large ' + childElementCount );
			} else {
				let largeTxtArray = [];
				for ( let i = 0; i < this.children.length; i ++ ) {
					if ( (
						Math.round( window.devicePixelRatio * 100 ) == 100
					) ) {
						if ( this.children[i].innerText.length > 39 ) {
							largeTxtArray.push( this.children[i] )
						}
					} else if ( Math.round( window.devicePixelRatio * 100 ) == 110 ) {
						if ( this.children[i].innerText.length > 34 ) {
							largeTxtArray.push( this.children[i] )
						}
					} else if ( (
						            Math.round( window.devicePixelRatio * 100 ) == 125
					            ) || Math.round( window.devicePixelRatio * 100 ) == 150 ) {
						if ( this.children[i].innerText.length > 27 ) {
							largeTxtArray.push( this.children[i] )
						}
					}

				}
				if ( this.children.length === 9 && largeTxtArray.length >= 1 ) {
					$( this ).addClass( 'menu-l2-large ' + childElementCount );
					largeTxtArray = [];
				} else if ( this.children.length === 8 && largeTxtArray.length > 2 ) {
					$( this ).addClass( 'menu-l2-large ' + childElementCount );
					largeTxtArray = [];
				} else if ( this.children.length === 7 && largeTxtArray.length > 4 ) {
					$( this ).addClass( 'menu-l2-large ' + childElementCount );
					largeTxtArray = [];
				} else if ( this.children.length === 6 && largeTxtArray.length > 5 ) {
					$( this ).addClass( 'menu-l2-large ' + childElementCount );
					largeTxtArray = [];
				} else {
					$( this ).addClass( 'menu-l2-normal ' + childElementCount );
					largeTxtArray = [];
				}
			}
		} );
	}
}

MenuWidthCalc()


// --- Mobile menu (mobile) ---
// Open/Close navigation - Mobile Menu will not closed until user clicks on close icon.

// Keep topbar-wrapper size when topbar is fixed

function topbarResizer() {

	// Do not affect main page at all
	if ( ! $( 'body' ).hasClass( 'body--home' ) ) {
		var wasFixed = 0,
			time = 0

		if ( $( '.header-topbar' ).hasClass( 'fixed' ) ) {
			wasFixed = 1;
			$( '.header-topbar' ).removeClass( 'fixed' );
			time = 300;
		}
	}
}

$( document ).ready( function () {
	$(window).resize( lodash.debounce(function () {
		topbarResizer();
	}, 100));
	topbarResizer();
} );

//Breadcrum will hide on click

const headerTopBarNode = document.querySelector('.header-topbar');
headerTopBarNode.addEventListener('click', () => {
   const subNavigationNode = document.querySelector('.sub-navigation-wrapper');
   if(subNavigationNode){
      subNavigationNode.classList.add('below-header');
   }
})

/**
 * Accessibility bug fix - Site Search box navigation looping for improved accessibility
**/
$(document).ready(function () {
    const $container = $('.header-search-inner');

    const $firstElement = $container.find('.header-search-close');

    $container.on('keydown', function (e) {
        if (e.key === 'Tab') {
            const focusableSelectors = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
            const $focusableElements = $container.find(focusableSelectors).filter(':visible');
            const $lastElement = $focusableElements.last();

            if (e.shiftKey) {
                if (document.activeElement === $firstElement[0]) {
                    e.preventDefault();
                    $lastElement.focus();
                }
            } else {
                if (document.activeElement === $lastElement[0]) {
                    e.preventDefault();
                    $firstElement.focus();
                }
            }
        }
    });

    const mutationCallback = function (mutationsList, observer) {};
    const observer = new MutationObserver(mutationCallback);
    observer.observe($container[0], {
        childList: true,
        subtree: true,
    });
});

$(document).on('click', '.section--searchPage .filters-clear', function () {
    const currentUrl = new URL(window.location.href);
    
    const searchQuery = currentUrl.searchParams.get('s');
    const paged = currentUrl.searchParams.get('paged');
    const sortByDate = currentUrl.searchParams.get('SortByDate');

    const params = new URLSearchParams();
    if (searchQuery) params.set('s', searchQuery);
    if (paged) params.set('paged', paged);
    if (sortByDate) params.set('SortByDate', sortByDate);

    const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${params.toString()}`;
    window.location.href = newUrl;
});


